import { translitToRus } from 'app/utils';
import { createSelector } from 'reselect';
const trailerState = (state) => state.trailer;

export const itemsTrailerSelector = createSelector(trailerState, (trailer) => trailer.items);
export const searchValueTrailerSelector = createSelector(trailerState, (trailer) => trailer.searchValue);
export const selectedItemTrailerSelector = createSelector(trailerState, (trailer) => trailer.selectedItem);
export const sortSelectedItemTrailerSelector = createSelector(trailerState, (trailer) => trailer.sortSelectedItem);
export const sortItemsTrailerSelector = createSelector([itemsTrailerSelector, sortSelectedItemTrailerSelector, searchValueTrailerSelector], (items, sortSelectedItem, searchValue) => {
    const compareFn = (a, b) => {
        switch (sortSelectedItem.name) {
            case 'number':
                switch (sortSelectedItem.order) {
                    case 'ASC':
                        return b.number === null
                            ? -1
                            : a.number === null
                              ? 1
                              : a.number.localeCompare(b.number, {
                                    sensitivity: 'base',
                                });
                    case 'DESC':
                        return b.number === null
                            ? -1
                            : a.number === null
                              ? 1
                              : b.number.localeCompare(a.number, {
                                    sensitivity: 'base',
                                });
                }
                break;
            case 'vin':
                switch (sortSelectedItem.order) {
                    case 'ASC':
                        return b.vin === null
                            ? -1
                            : a.vin === null
                              ? 1
                              : a.vin.localeCompare(b.vin, {
                                    sensitivity: 'base',
                                });
                    case 'DESC':
                        return b.vin === null
                            ? -1
                            : a.vin === null
                              ? 1
                              : b.vin.localeCompare(a.vin, {
                                    sensitivity: 'base',
                                });
                }
                break;
            default:
                switch (typeof a[sortSelectedItem.name]) {
                    case 'string':
                        switch (sortSelectedItem.order) {
                            case 'ASC':
                                return a.number.localeCompare(b.number, {
                                    sensitivity: 'base',
                                });
                            case 'DESC':
                                return b.number.localeCompare(a.number, {
                                    sensitivity: 'base',
                                });
                        }
                        break;
                    case 'number':
                        switch (sortSelectedItem.order) {
                            case 'ASC':
                                return a[sortSelectedItem.name] - b[sortSelectedItem.name];
                            case 'DESC':
                                return b[sortSelectedItem.name] - a[sortSelectedItem.name];
                        }
                        break;
                }
        }
    };

    if (searchValue.length) {
        return items.filter((item) => translitToRus(String(item.fuel_level_sensor)).indexOf(translitToRus(searchValue)) >= 0 || translitToRus(item.number)?.indexOf(translitToRus(searchValue)) >= 0 || translitToRus(item.vin)?.indexOf(translitToRus(searchValue)) >= 0).sort(compareFn);
    }

    return items.sort(compareFn);
});
